import React, { useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FloatingLabel,
  Form,
  Row
} from "react-bootstrap";

import { saveAs } from "file-saver";
import QRCode from "qrcode.react";

function QR() {
  const qrCodeRef = useRef(null);
  const initialValue = "Welcome to Dolt Labs Tools!";
  const [value, setValue] = useState(initialValue);

  // Function to handle textarea changes
  const handleChange = (e) => {
    setValue(e.target.value);
  };

  // Function to reset the textarea value to initial value
  const handleReset = () => {
    setValue(initialValue);
  };

  
  
  const handleDownload = () => {
    const canvas = qrCodeRef.current.querySelector("canvas");
    if (canvas) {
      canvas.toBlob((blob) => {
        saveAs(blob, "qrcode.png");
      });
    }
  };

  return (
    <div>
      <Row>
        <Col md="8" className="h-100 mb-3">
          <FloatingLabel controlId="floatingTextarea2" label="Enter Text">
            <Form.Control
              as="textarea"
              value={value}
              onChange={handleChange}
              placeholder="Enter Text Here"
              style={{ height: "100%" }}
            />
          </FloatingLabel>
          <Button variant="dark" className="mt-3 me-2" onClick={handleDownload}>Download</Button>
          <Button variant="outline-dark" className="mt-3" onClick={handleReset}>
            Reset
          </Button>
        </Col>
        <Col className="order-md-last order-first mb-3  text-center">
          <Card ref={qrCodeRef}>
            <CardHeader>QR Code</CardHeader>
            <CardBody>
              <QRCode
                value={value}
                size={256}
                bgColor="#ffffff"
                fgColor="#000000"
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default QR;
